import type { LeadFlow } from '@/data'
import type { PaginatedResponse, ListParams } from '@/api/client'
import { buildQuery } from '@/api/client'
import api from '..'

export type PaginatedFlows = PaginatedResponse<LeadFlow>

export async function getFlows(params?: ListParams): Promise<PaginatedFlows> {
  const res = await api.get('/flows', { params: buildQuery(params) })
  return { data: res.data.data, meta: res.data.meta }
}
